import {
  LoadingOverlay,
  Box,
  Group,
  Button,
  Divider,
  Stack,
  TextInput,
  Title,
} from '@mantine/core';

import { useConfigTelegram } from '../hooks/use-config-telegram';
import { TelegramChatRouting } from './telegram-chat-routing';

const TelegramBotSettings = () => {
  const {
    form,
    isLoading,
    handleSubmit,
  } = useConfigTelegram();

  return (
    <Box style={{ position: 'relative' }}>
      <LoadingOverlay
        visible={isLoading}
        overlayProps={{ blur: 2 }}
      />

      <Title order={5} mb="md">Основные настройки</Title>

      <form onSubmit={form.onSubmit(handleSubmit)}>
        <TextInput
          label="Token бота"
          withAsterisk
          key={form.key('botToken')}
          {...form.getInputProps('botToken')}
        />

        <TextInput
          label="ID чата для платежей"
          withAsterisk
          key={form.key('depositsChatId')}
          {...form.getInputProps('depositsChatId')}
        />

        <TextInput
          label="ID чата для выводов"
          withAsterisk
          key={form.key('withdrawalsChatId')}
          {...form.getInputProps('withdrawalsChatId')}
        />

        <Group justify="flex-start" mt="30">
          <Button type="submit" loading={isLoading}>
            Сохранить
          </Button>
        </Group>
      </form>
    </Box>
  );
};

export const Telegram = () => {
  return (
    <Stack gap="xl">
      <TelegramBotSettings />
      <Divider />
      <TelegramChatRouting />
    </Stack>
  );
};
